// these need to eventually be their own routes
export const USER_MANAGEMENT_PATH = "user-management";
const DATA_MANAGEMENT_PATH = "data-management";

export const SettingsPaths = {
    generalSettings: "general-settings",
    complianceSettings: "compliance-settings",
    mySettings: "my-settings",
    agentDesktop: "agent-desktop",
    callBranding: "call-branding",
    brandSecrets: "brand-secrets",
    // TODO move these to their own routes
    userManagementPageUsers: `${USER_MANAGEMENT_PATH}/users`,
    userManagementPageTeams: `${USER_MANAGEMENT_PATH}/teams`,
    userManagementPageSkills: `${USER_MANAGEMENT_PATH}/skills`,
    userManagementPageCustomAttributes: `${USER_MANAGEMENT_PATH}/custom-attributes`,
    userManagementNewUser: `${USER_MANAGEMENT_PATH}/users/new`,
    userManagementEditUser: `${USER_MANAGEMENT_PATH}/users/:userId`,
    userManagementTeam: `${USER_MANAGEMENT_PATH}/teams/new`,
    userManagementTeamEdit: `${USER_MANAGEMENT_PATH}/teams/:teamId`,
    userManagementSkillsNew: `${USER_MANAGEMENT_PATH}/skills/new`,
    userManagementSkillsEdit: `${USER_MANAGEMENT_PATH}/skills/:skillId`,
    userManagementCustomAttributesNew: `${USER_MANAGEMENT_PATH}/custom-attributes/new`,
    userManagementCustomAttributesEdit: `${USER_MANAGEMENT_PATH}/custom-attributes/:attributeId`,
    // TODO move these to their own routes
    customDefinition: `${DATA_MANAGEMENT_PATH}/object-types/:objectType`,
    objectTypes: `${DATA_MANAGEMENT_PATH}/object-types`,
    eventManagement: `${DATA_MANAGEMENT_PATH}/events`,
    externalTransferPhonebook: "external-transfer-phonebook",
    contactLists: "contact-lists",
    integrations: "integrations",
    phoneNumbers: "phone-numbers",
    recordings: "recordings",
    trust: "trust",
    sip: "sip",
    yourData: "your-data",
    routingRules: "routing-rules",
} as const satisfies Record<string, string>;
